import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Role } from '../models/group';
import { Page } from '../models/page';

@Injectable()
export class UserSession {

  currentUrl : string = '';
  username : string = '';
  avatarUrl : string | null = null;
  authorities : Role[] = [];
  accessToken: string = '';;
  authenticated: boolean = false;
  isAuthenticated : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  appPages : Page[] = [];
  showSideMenu = false;
  showMenuTop = false;
  showUserDropdown = false;

  public isAuthenticatedOnChange() : Observable<boolean> {
      return this.isAuthenticated.asObservable();
  }

  public refreshAuthenticated() {
    return this.authenticated = this.isAuthenticated.getValue();
}

  public refreshSession() {
      let avatar = localStorage.getItem('avatar') ;
      let username = localStorage.getItem('username') ;

      this.avatarUrl = avatar == 'null' ? null : avatar;
      this.username = username ?? '';
  }

  public setAvatar(avatarUrl : string) {
      localStorage.setItem('avatar', avatarUrl);
      this.avatarUrl = avatarUrl == 'null' ? null : avatarUrl;
  }

  public setUsername(username : string) {
    localStorage.setItem('username', username);
    this.username = username;
}
}